import { DateTime } from "luxon";

/**
 * User input for time.  Expects input in a format matching Workday's formatting.
 */
export class EventTimeInput {
    /**
     * Raw input string.
     */
    public readonly raw: string;

    /**
     * Parsed input string.  Might be invalid.
     */
    public readonly parsed: DateTime;

    /**
     * User-readable instructions for properly formatting their input.
     */
    public readonly formatInstructions = "For example, 3:00 PM or 11:00AM";

    constructor(raw: string) {
        this.raw = raw;
        this.parsed = this._parse();
    }

    private _parse(): DateTime {
        const timeStr = this.raw.toUpperCase().replace(/\s+/g, "");
        return DateTime.fromFormat(timeStr, "h:mma");
    }
}
